import apiWorker from '../apiWorker'

const zendesk = {

    tickets: (get) => apiWorker('get',   `/v1/integrations/zendesk/tickets`, null, true),

}

export default zendesk;